import { useCallback, useRef } from "react";
import { useRouter } from "next/router";

import authService from "../../../services/auth.service";
import clearAuthSession from "../browser/clearAuthSession";
import { useToastUpdater } from "../../../context/toastContext/toastContext";

const useSignOut = () => {
    const { addToast } = useToastUpdater();
    const router = useRouter();

    // Ensures the sign out logic is can only run once per call.
    const isLoggingOut = useRef(false);

    return useCallback(async () => {
        if (isLoggingOut.current) {
            return;
        }

        isLoggingOut.current = true;

        // Invalidate tokens API side.
        try {
            await authService.logout();
            clearAuthSession({
                redirect: false,
            });
            router.push("/auth/logged-out");
        } catch (_error) {
            isLoggingOut.current = false;
            addToast("Unable to logout. Please contact support", "error", "");
        }
    }, [router, addToast]);
};

export default useSignOut;
